import React, { FC, useMemo } from 'react';
import { FormCol, FormRow, TextControl, useScopedSelector } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import { InvalidUsernameFormPageState } from '../../../../../interfaces/InvalidUsernameFormPageState';

export interface UsernameConfirmationProps {
  isSubmitting: boolean;
}

const UsernameConfirmation: FC<UsernameConfirmationProps> = ({ isSubmitting }) => {
  const { t } = useTranslation('InvalidUsernameFormPage');
  const formState = useScopedSelector((state: InvalidUsernameFormPageState) => state);
  const tempUsername = useMemo(() => formState?.usernameFormValues?.username, [formState?.usernameFormValues?.username]);

  return (
    <FormRow>
      <FormCol label={`${t('confirmationLabel')}`} labelMarginBottom={36}>
        <TextControl
          onPaste={(event) => event.preventDefault()}
          maxErrorMessageRows={10}
          required
          disabled={isSubmitting}
          name="confirmation"
          validators={{
            isEqualToUsername: (value: string) => value === '' || value === null || tempUsername === '' || tempUsername === null || value === tempUsername,
          }}
          validationMessages={{
            isEqualToUsername: t('usernameConfirmation'),
          }}
        />
      </FormCol>
    </FormRow>
  );
};

export default UsernameConfirmation;
